import { ShieldCheck, Sprout } from "lucide-react";

/**
 * Trust badge — shows reliability score (0-100) computed from signup approvals + sale completions.
 * Falls back to a "New member" pill when there's no data yet.
 *
 * Props:
 *  - trust: { score: number|null, total_actions: number, shifts_credited: number, sales_completed: number, is_new_member: boolean }
 *  - size: "sm" | "md"
 *  - testId
 */
export default function TrustBadge({ trust, size = "md", testId = "trust-badge" }) {
  if (!trust) return null;

  const isNew = trust.is_new_member || trust.score == null;
  const score = trust.score ?? 0;

  // Color by score tier
  const tier =
    isNew
      ? { bg: "#FDF0D5", fg: "#B37A2C", border: "#EED8A1", label: "New member" }
      : score >= 90
        ? { bg: "#E8F0E5", fg: "#3B5742", border: "#B6CFB0", label: `${score}% trust` }
        : score >= 70
          ? { bg: "#FDF0D5", fg: "#B37A2C", border: "#EED8A1", label: `${score}% trust` }
          : { bg: "#FBE5E0", fg: "#A8533F", border: "#EBC0B5", label: `${score}% trust` };

  const cls = size === "sm" ? "px-2 py-0.5 text-xs gap-1" : "px-3 py-1 text-sm gap-1.5";

  return (
    <span
      data-testid={testId}
      title={
        isNew
          ? "This member is new to Bahoi"
          : `${trust.shifts_credited} verified shift${trust.shifts_credited === 1 ? "" : "s"} · ${trust.sales_completed} completed sale${trust.sales_completed === 1 ? "" : "s"} · ${trust.total_actions} total actions`
      }
      className={`inline-flex items-center rounded-full font-semibold border ${cls}`}
      style={{ background: tier.bg, color: tier.fg, borderColor: tier.border }}
    >
      {isNew ? <Sprout className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} /> : <ShieldCheck className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />}
      {tier.label}
    </span>
  );
}
